import React from 'react';
import { Link } from 'react-router-dom';
import './featureContent.css';

function FeatureCtaButton({ to, href, children, target, rel, className = '' }) {
    const destination = href || to;
    const isExternal = typeof destination === 'string' && (/^https?:\/\//i.test(destination) || destination.startsWith('//'));

    if (isExternal) {
        return (
            <a
                href={destination}
                className={`fc-btn ${className}`.trim()}
                target={target || '_blank'}
                rel={rel || 'noopener noreferrer'}
            >
                {children}
            </a>
        );
    }

    return (
        <Link to={destination} className={`fc-btn ${className}`.trim()}>
            {children}
        </Link>
    );
}

export default FeatureCtaButton;
